import { useQuery } from "@tanstack/react-query";
import { BRAND_ME_SEARCH_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

interface SearchBrandUserPayload {
  searchQuery?: string;
  brandOrganisationId: string;
  accountStatuses?: string[];
  pageNo?: number;
  limit?: number;
  brandIds?: string[];
  isEnabled?: boolean;
}

export const useSearchBrandUser = (payload: SearchBrandUserPayload) => {
  const {
    data: employeesData,
    isFetching: isFetchingEmployees,
    error: employeesError,
    isSuccess,
  } = useQuery({
    queryKey: [
      ...BRAND_ME_SEARCH_QUERY_KEY(payload.brandOrganisationId),
      payload,
    ],
    queryFn: () => OrganisationService.searchBrandUser(payload),
    enabled: !!payload.brandOrganisationId || payload.isEnabled,
  });
  return {
    employeesData,
    isFetchingEmployees,
    employeesError,
    isSuccess,
  };
};
